import { _Item } from '~/interfaces';
import { ENSIGNS_CATEGORY } from '~/interfaces';
import { Ensign } from '~/vortex';

import ResponseItemMap from './index';

export const prepareEnsigns = (responseEnsigns: Ensign[]): Ensign[] => {
    const rareEnsigns: Ensign[] = [];
    const ensigns = responseEnsigns
        .map((item: Ensign & _Item) => {
            if (ResponseItemMap.isUniqueItem(ENSIGNS_CATEGORY, item)) {
                item.isUniqueItem = true;
            }

            return item;
        })
        .filter((item) => {
            return !ResponseItemMap.getExcludedEnsignsIds().includes(item.id);
        });

    return [...rareEnsigns, ...ensigns];
};
